import { render } from "./viewAnotatedForm.vue?vue&type=template&id=1e704f37&scoped=true"
import script from "./viewAnotatedForm.js?vue&type=script&lang=js"
export * from "./viewAnotatedForm.js?vue&type=script&lang=js"

import "./viewAnotatedForm.vue?vue&type=style&index=0&id=1e704f37&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e704f37"]])

export default __exports__